import React from 'react';
import DownloadOnGooglePlayButton from './DownloadOnGooglePlayButton';
import DownloadOnTheAppStoreButton from './DownloadOnTheAppStoreButton';
import { Row } from 'library/ui';

export default function DownloadTheAppButtons() {
    return (
        <Row wrap>
            <DownloadOnTheAppStoreButton />
            <DownloadOnGooglePlayButton />
        </Row>
    );
}
